import { AxiosResponse } from "axios";
import { axiosApi } from "../../helpers";
import { ENDPOINTS_SES, URL_SES } from "../../constants/api_endpoints";
import { IAddDataElemProps, IAddingDataElemResponse } from "../../types/ses/sesDataElemTypes";
import { IResponse } from "../../types/statusTypes";

const addDataElement = async ({ robotId, data }: IAddDataElemProps): Promise<IAddingDataElemResponse> => {
	try {
		const response: AxiosResponse<IResponse> = await axiosApi.post(`${URL_SES}/${ENDPOINTS_SES.DATA_ADD}/${robotId}`, {
			data: JSON.stringify(data),
		});
		return response.data;
	} catch (error) {
		throw new Error(error instanceof Error ? error.message : String(error));
	}
};

export default addDataElement;
